<div _ngcontent-c0="" class="app-content ui basic segment container">
  <div _ngcontent-c3="" class="ui basic segment wrapper">

    <div class="full-width ui basic segment">

      <!-- <app-breadcrumb></app-breadcrumb> -->

      <h1 class="ui block header">
        Terms and Conditions
      </h1>

      <div class="ui basic segment">
        <div>
          <p>Welcome to our site. We maintain this web site as a service to our staff and customers. By
            using our site, you are agreeing to comply with and be bound by the following terms of use. Please review
            the following terms carefully. If you do not agree to these terms, you should not use this site.</p>
          <ol>
            <li>
              <h4>Acceptance of Agreement.</h4>
              You agree to the terms and conditions outlined in this Terms of Use Agreement ("Agreement") with respect
              to our site (the "Site"). This Agreement constitutes the entire and only agreement between us and you, and
              supersedes all prior or contemporaneous agreements, representations, warranties and understandings with
              respect to the Site, the content, products or services provided by or through the Site, and the subject
              matter of this Agreement. This Agreement may be amended at any time by us from time to time without
              specific notice to you. The latest Agreement will be posted on the Site, and you should review this
              Agreement prior to using the Site.
            </li>
            <li>
              <h4>Copyright.</h4>
              The content, organization, graphics, design, compilation, magnetic translation, digital conversion and
              other matters related to the Site are protected under applicable copyrights, trademarks and other
              proprietary (including but not limited to intellectual property) rights. The copying, redistribution, use
              or publication by you of any such matters or any part of the Site, except as allowed by Section 4, is
              strictly prohibited. You do not acquire ownership rights to any content, document or other materials
              viewed through the Site. The posting of information or materials on the Site does not constitute a waiver
              of any right in such information and materials.
            </li>
            <li>
              <h4>Service Marks.</h4>
              Products and names mentioned on the Site may be trademarks of their respective owners.
            </li>
            <li>
              <h4>Limited Right to Use.</h4>
              The viewing, printing or downloading of any content, graphic, form or document from the Site grants you
              only a limited, nonexclusive license for use solely by you for your own personal use and not for
              republication, distribution, assignment, sublicense, sale, preparation of derivative works or other use.
              No part of any content, form or document may be reproduced in any form or incorporated into any
              information retrieval system, electronic or mechanical, other than for your personal use (but not for
              resale or redistribution).
            </li>
            <li>
              <h4>Editing, Deleting and Modification</h4>
              We reserve the right in our sole discretion to edit, delete or modify any documents, information or other
              content appearing on the Site.
            </li>
            <li>
              <h4>Indemnification</h4>
              You agree to indemnify, defend and hold us and our partners, attorneys, staff, advertisers, product and
              service providers, and affiliates (collectively and individually, "Affiliated Parties") harmless from any
              liability, loss, claim and expense, including reasonable attorney's fees, related to your violation of
              this Agreement or use of the Site.
            </li>
            <li>
              <h4>Non-transferable</h4>
              Your right to use the Site is not transferable. Any password or right given to you to obtain information
              or documents is not transferable.
            </li>
            <li>
              <h4>Disclaimer and Limits</h4>
              <p>THE INFORMATION FROM OR THROUGH THE SITE ARE PROVIDED "AS-IS," "AS AVAILABLE," AND ALL
                WARRANTIES, EXPRESS OR IMPLIED, ARE DISCLAIMED (INCLUDING BUT NOT LIMITED TO THE DISCLAIMER OF ANY
                IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE). THE INFORMATION AND
                SERVICES MAY CONTAIN BUGS, ERRORS, PROBLEMS OR OTHER LIMITATIONS. WE AND OUR AFFILIATED PARTIES HAVE NO
                LIABILITY WHATSOEVER FOR YOUR USE OF ANY INFORMATION OR SERVICE. IN PARTICULAR, BUT NOT AS A LIMITATION
                THEREOF, WE AND OUR AFFILIATED PARTIES ARE NOT LIABLE FOR ANY INDIRECT, SPECIAL, INCIDENTAL OR
                CONSEQUENTIAL DAMAGES (INCLUDING DAMAGES FOR LOSS OF BUSINESS, LOSS OF PROFITS, LITIGATION, OR THE
                LIKE), WHETHER BASED ON BREACH OF CONTRACT, BREACH OF WARRANTY, TORT (INCLUDING NEGLIGENCE), PRODUCT
                LIABILITY OR OTHERWISE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THE NEGATION OF DAMAGES SET
                FORTH ABOVE ARE FUNDAMENTAL ELEMENTS OF THE BASIS OF THE BARGAIN BETWEEN US AND YOU. THIS SITE AND THE
                PRODUCTS, SERVICES, AND INFORMATION PRESENTED WOULD NOT BE PROVIDED WITHOUT SUCH LIMITATIONS. NO ADVICE
                OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM US THROUGH THE SITE SHALL CREATE ANY
                WARRANTY, REPRESENTATION OR GUARANTEE NOT EXPRESSLY STATED IN THIS AGREEMENT. WE DO NOT PROVIDE LEGAL
                ADVICE NOR ENTER INTO ANY ATTORNEY-CLIENT RELATIONSHIP.</p>
              <p>ALL RESPONSIBILITY OR LIABILITY FOR ANY DAMAGES CAUSED BY VIRUSES CONTAINED WITHIN THE
                ELECTRONIC FILE CONTAINING THE FORM OR DOCUMENT IS DISCLAIMED. WE WILL NOT BE LIABLE TO YOU FOR ANY
                INCIDENTAL, SPECIAL OR CONSEQUENTIAL DAMAGES OF ANY KIND THAT MAY RESULT FROM USE OF OR INABILITY TO USE
                OUR SITE. OUR MAXIMUM LIABILITY TO YOU UNDER ALL CIRCUMSTANCES WILL BE EQUAL TO THE PURCHASE PRICE YOU
                PAY FOR ANY SERVICES OR INFORMATION.</p>
            </li>
            <li>
              <h4>Use of Information.</h4>
              We reserve the right, and you authorize us, to the use and assignment of all information regarding Site
              uses by you and all information provided by you in any manner consistent with our Privacy Policy. All
              remarks, suggestions, ideas, graphics, or other information communicated by you to us through the Site
              (collectively, the "Submission") will forever be the property of CAC Services Portal. CAC Services Portal
              will not be required to treat any Submission as confidential, and will not be liable for any ideas for its
              business (including without limitation, product, service or advertising ideas) and will not incur any
              liability as a result of any similarities that may appear in future CAC Services Portal products, services
              or operations. Without limitation, CAC Services Portal will have exclusive ownership of all present and
              future existing rights to the Submission of every kind and nature everywhere. CAC Services Portal will be
              entitled to use the Submission for any commercial or other purpose whatsoever, without compensation to you
              or any other person sending the Submission. You acknowledge that you are responsible for whatever material
              you submit, and you, not CAC Services Portal, have full responsibility for the message, including its
              legality, reliability, appropriateness, originality, and copyright.
            </li>
            <li>
              <h4>Third-Party Services.</h4>
              We may allow access to or advertise third-party product or service providers ("Merchants") from which you
              may purchase certain goods or services. You understand that we do not operate or control the products or
              services offered by Merchants. Merchants are responsible for all aspects of order processing, fulfilment,
              billing and customer service. We are not a party to the transactions entered into between you and
              Merchants. You agree that use of such Merchants is AT YOUR SOLE RISK AND IS WITHOUT WARRANTIES OF ANY KIND
              BY US, EXPRESSED, IMPLIED OR OTHERWISE INCLUDING WARRANTIES OF TITLE, FITNESS FOR PURPOSE, MERCHANTABILITY
              OR NON-INFRINGEMENT. UNDER NO CIRCUMSTANCES ARE WE LIABLE FOR ANY DAMAGES ARISING FROM THE TRANSACTIONS
              BETWEEN YOU AND MERCHANTS OR FOR ANY INFORMATION APPEARING ON MERCHANT SITES OR ANY OTHER SITE LINKED TO
              OUR SITE.
            </li>
            <li>
              <h4>Third-Party Merchant Policies.</h4>
              All rules, policies (including privacy policies) and operating procedures of Merchants will apply to you
              while on such sites. We are not responsible for information provided by you to Merchants. We and the
              Merchants are independent contractors and neither party has authority to make any representations or
              commitments on behalf of the other.
            </li>
            <li>
              <h4>Privacy Policy</h4>
              Our Privacy Policy, as it may change from time to time, is a part of this Agreement.
            </li>
            <li>
              <h4>13. Payments.</h4>
              You represent and warrant that if you are purchasing something from us or from Merchants that (i) any
              credit information you supply is true and complete, (ii) charges incurred by you will be honoured by your
              credit card company, and (iii) you will pay the charges incurred by you at the posted prices, including
              any applicable taxes.
            </li>
            <li>
              <h4>Securities Laws</h4>
              This Site may include statements concerning our operations, prospects, strategies, financial condition,
              future economic performance and demand for our services, as well as our intentions, plans and objectives
              (particularly with respect to service offerings), that are forward-looking statements. These statements
              are based upon a number of assumptions and estimates which are subject to significant uncertainties, many
              of which are beyond our control. When used on our Site, words like "anticipates," "expects," "believes,"
              "estimates," "seeks," "plans," "intends," "will" and similar expressions are intended to identify
              forward-looking statements designed to fall within securities law safe harbours for forward-looking
              statements. The Site and the information contained herein does not constitute an offer or a solicitation
              of an offer for sale of any securities. None of the information contained herein is intended to be, and
              shall not be deemed to be, incorporated into any of our securities-related filings or documents.
            </li>
            <li>
              <h4>Links to Other Web Sites.</h4>
              The Site contains links to other web sites. We are not responsible for the content, accuracy or opinions
              express in such web sites, and such web sites are not investigated, monitored or checked for accuracy or
              completeness by us. Inclusion of any linked web site on our Site does not imply approval or endorsement of
              the linked web site by us. If you decide to leave our Site and access these third-party sites, you do so
              at your own risk.
            </li>
            <li>
              <h4>Copyrights and Copyright Agents</h4>
              We respect the intellectual property of others, and we ask you to do the same. If you believe that your
              work has been copied in a way that constitutes copyright infringement, please provide our Copyright Agent
              the following information: (a) An electronic or physical signature of the person authorized to act on
              behalf of the owner of the copyright interest; (b) A description of the copyrighted work that you claim
              has been infringed; (c) A description of where the material that you claim is infringing is located on the
              Site; (d) Your address, telephone number, and email address; (e) A statement by you that you have a good
              faith belief that the disputed use is not authorized by the copyright owner, its agent, or the law; and
              (f) A statement by you, made under penalty of perjury, that the above information in your Notice is
              accurate and that you are the copyright owner or authorized to act on the copyright owner's behalf. Our
              Copyright Agent for Notice of claims of copyright infringement on the Site can be reached by directing an
              e-mail to the Copyright Agent at admin@cac.gov.ng
            </li>
            <li>
              <h4>Proposed Service Offerings</h4>
              All descriptions of proposed products and services are based on assumptions subject to change and you
              should not rely on the availability or functionality of products or services until they are actually
              offered through the Site. We reserve the right in its sole discretion to determine how registration and
              other promotions will be awarded. This determination includes, without limitation, the scope, nature and
              timing of all such awards.
            </li>
            <li>
              <h4>Information and Press Releases</h4>
              The Site contains information and press releases about us. While this information was believed to be
              accurate as of the date prepared, we disclaim any duty or obligation to update this information or any
              press releases. Information about companies other than ours contained in the press release or otherwise,
              should not be relied upon as being provided or endorsed by us.
            </li>
          </ol>
        </div>
      </div>

    </div>
  </div>
</div>
